import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../App.css'
import './Settings.css'
import PlainHeader from '../components/PlainHeader'
import DeleteModal from '../components/DeleteModal'
import Footer from '../components/Footer'

class Settings extends Component {
  constructor() {
    super()
    this.addSearchTerm = this.addSearchTerm.bind(this)
    this.deleteSearchTerm = this.deleteSearchTerm.bind(this)
    this.goToDetail = this.goToDetail.bind(this)
    this.renderSearch = this.renderSearch.bind(this)
    this.uploadSearches = this.uploadSearches.bind(this)
  }
  addSearchTerm(event) {
    event.preventDefault()
    console.log(this.searchTerm.value)
    if (this.searchTerm.value.trim()) {
      const term = {
        id: 'term-' + Date.now(),
        searchTerm: this.searchTerm.value.trim(),
        results: []
      }
      this.props.addSearchTerm(term)
    }
    this.addTermForm.reset()
  }
  deleteSearchTerm(event, id) {
    event.preventDefault()
    this.props.deleteSearchTerm(id)
    console.log('Settings says delete: ', id)
  }
  goToDetail(event, id) {
    event.preventDefault()
    this.context.router.history.push(`/settings/${id}`)
  }
  downloadSearches(e) {
    const dlSearches = JSON.stringify(this.props.searches)
    let element = document.createElement('a')
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(dlSearches))
    element.setAttribute('download', 'SearchGull.txt')
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }
  uploadSearches(e) {
    let file = e.target.files[0]
    console.log('Uploading this: ', file)
    let reader = new FileReader()
    reader.onload = (e) => {
      let text = reader.result
      let searches = JSON.parse(text)
      console.log('Reader result: ', searches)
      this.props.overwriteSearches(searches)
      document.getElementById('upload-form').reset()
    }
    reader.readAsText(file)
  }
  renderResults() {
    if (this.props.searches.length > 0) {
      return (
        <div className="search-term-edit-container">
          {this.props.searches.map(this.renderSearch)}
        </div>
      )
    } else {
      return (
        <p>You have no search terms. Use the box below to add some.</p>
      )
    }
  }
  renderSearch(search, index) {
    let theClasses = 'search-term-edit'
    if (index%2 === 1) {
      theClasses += ' search-term-edit-odd'
    }
    return (
      <div key={search.id} className={theClasses}>
        <div className="search-term-edit-term">
          {search.searchTerm} ({search.results.length} Results)
        </div>
        <div className="search-term-edit-buttons">
          <div>
          <button className="btn" onClick={(e) => this.goToDetail(e, search.id)}>Edit</button>
          </div> 
          <div>
            <button className="btn btn-delete" onClick={(e) => this.deleteSearchTerm(e, search.id)}>Delete</button>
          </div>
        </div>
      </div>
    )
  }
  render() {
    if (this.props.loading) {
      console.log("Loading data.")
      return (
        <div>Loading...</div>
      )
    } else {
      return (
        <div className="main">
          <PlainHeader />
          <div className="container settings">
            <h1>
              Settings
            </h1>
            <div>
              <h2>Your Search Terms</h2>
              {this.renderResults()}
            </div>
            
            <div>
              <h2>Add a Search Term</h2>
              <form ref={(input) => this.addTermForm = input} onSubmit={(e) => this.addSearchTerm(e)}>
                <input className="searchterm-input" required name="searchterm" type="text" ref={(input) => this.searchTerm = input}/>
                <button className="btn-searchterm-input">Add</button>
              </form>
            </div>
            <div className="settings-save">
              <h2>Save Your Work!</h2>
              <p>SearchGull doesn't use a remote database, so the search terms you enter only exist on this device and in this particular browser. 
                But you can save all of your work, including your search terms and results, in a file that you can download. 
                That way, you could upload your work later - even on a different device - and avoid having to type them all out again. 
                </p>
              <button className="btn" onClick={(e) => this.downloadSearches(e)}>Save</button>
            </div>
            <div>
              <h2>Upload Saved Search Terms</h2>
              <p>If you have previously saved your search terms, you can upload them here.  Please note that doing so will overwrite any exisiting search terms.</p>
              <form id="upload-form" className="upload-wrapper"> Choose File
                <input type="file" id="files" name="files[]" className="upload-input" placeholder="Choose File" onChange={(e) => this.uploadSearches(e)} />
              </form>
            </div>
          </div>
          <DeleteModal 
            closeDeleteModal={this.props.closeDeleteModal} 
            confirmDeleteSearchItem={this.props.confirmDeleteSearchItem}
            hideDeleteModal={this.props.hideDeleteModal} />
          <Footer />
        </div>
      )
    }
   
  }
}

Settings.contextTypes = {
  router: PropTypes.object
}

export default Settings;


// WEBPACK FOOTER //
// ./src/pages/Settings.js